import { useCreateInvoice } from "@verde/entities";
import { CircleStackIcon, ReturnIcon } from "@verde/icons";
import { Alert, Button } from "@verde/ui-core";
import React, { useCallback } from "react";
import { useCreditDialog } from "./credit-dialog";

function CreditDialogExpired() {
  const create = useCreateInvoice();

  const { selectedCredit, setSelectedInvoice, setKind, onClose } =
    useCreditDialog();

  const handleGenerate = useCallback(async () => {
    if (!selectedCredit) {
      setKind("default");
      return;
    }

    const invoice = await create.mutateAsync({
      kind: "pix",
      value: selectedCredit?.value,
    });

    setSelectedInvoice(invoice);
  }, [selectedCredit, create, setKind, setSelectedInvoice]);

  return (
    <div className="grid gap-4">
      <p className="text-lg font-semibold text-neutral-dark-2">
        O pagamento do código QR ainda não efetuado. Caso tenha realizado o
        pagamento, aguarde mais alguns instantes.
      </p>

      <Alert
        kind="warning"
        icon={<CircleStackIcon />}
        classNames={{
          base: "border",
        }}
      >
        Em caso de dúvidas entre em contato com seu gerente de relacionamento
      </Alert>

      <hr />

      <div className="grid gap-2">
        <Button
          kind="secondary"
          size="lg"
          icon={<ReturnIcon />}
          onClick={handleGenerate}
          loading={create.isLoading}
        >
          Tentar novamente
        </Button>
        <Button kind="secondary" size="lg" onClick={onClose}>
          Fechar
        </Button>
      </div>
    </div>
  );
}

export default React.memo(CreditDialogExpired);
